import { createApi } from '@reduxjs/toolkit/query/react';
import { newBackendAxiosBaseQuery } from '../../utils/axiosBaseQuery';
import { serializeQueryArgsWithTenant } from '../tenantCacheKey';

// Dedicated slice for the B2 archive / restore / anonymize mutations on
// bookings. These endpoints live on the new (ECS) backend at
// /admin/order/:id/{archive,restore,anonymize}; the rest of the booking
// graph (list, details, cancel, delete, payment) still lives on the
// legacy Lambda backend and stays in `bookingApiSlice`.
//
// Cross-slice cache invalidation (bookingList, bookingDetails on
// bookingApiSlice) is handled at the flow-hook call site by dispatching
// `bookingApiSlice.util.invalidateTags(...)` after a successful mutation.
// Same pattern as `seriesBookingApiSlice`.
export const bookingArchiveApiSlice = createApi({
    reducerPath: 'bookingArchiveApiSlice',
    serializeQueryArgs: serializeQueryArgsWithTenant,
    baseQuery: newBackendAxiosBaseQuery(),
    endpoints: (builder) => ({
        archiveBooking: builder.mutation<void, { bookingId: string, reason?: string, note?: string }>({
            query: ({ bookingId, reason, note }) => ({
                url: `/order/${bookingId}/archive`,
                method: 'POST',
                data: { reason, note },
            }),
        }),
        restoreBooking: builder.mutation<void, { bookingId: string }>({
            query: ({ bookingId }) => ({
                url: `/order/${bookingId}/restore`,
                method: 'POST',
            }),
        }),
        anonymizeBooking: builder.mutation<void, { bookingId: string }>({
            query: ({ bookingId }) => ({
                url: `/order/${bookingId}/anonymize`,
                method: 'POST',
            }),
        }),
    }),
});

export const {
    useArchiveBookingMutation,
    useRestoreBookingMutation,
    useAnonymizeBookingMutation,
} = bookingArchiveApiSlice;
